import styles from './styles.less';
import VideoPlayer from 'common/components/video-player';
import { observer, propTypes } from 'mobx-react';


@observer
class Trailer extends React.Component {
    static propTypes = {
        video: propTypes.objectOrObservableObject.isRequired,
        visible: React.PropTypes.bool
    };

    state = {
        clicked: false
    };

    componentWillReceiveProps(nextProps) {
        if (!nextProps.visible && this.state.clicked) {
            this.setState({ clicked: false });
        }
    }

    render() {
        const className = cx(styles.root, this.props.className);
        const backgroundImage = `url(${this.props.video.thumbnail})`;
        return (
            <div
                className={ className }
                onClick={ this.state.clicked ? null : this.handleClick }
                style={{ backgroundImage }}>
                { !this.state.clicked &&
                <div className={ styles.playButton }>
                    <span className={ styles.playText }>Play</span>
                    { this.props.video.title }
                </div> }
                <VideoPlayer
                    autoplay={ false }
                    className={ styles.videoPlayer }
                    playerProps={{
                        onVideoFinished: this.handleVideoFinished
                    }}
                    style={{ display: this.state.clicked ? null : 'none' }}
                    video={ this.state.clicked ? this.props.video : null }
                />
            </div>
        );
    }

    handleClick = (e) => {
        e.preventDefault();
        this.setState({ clicked: true });
    };

    handleVideoFinished = () => {
        this.setState({ clicked: false });
    };

}


export default Trailer;



/** WEBPACK FOOTER **
 ** ./src/show-page/components/trailer/index.js
 **/